import { useMutationWithErrorHandler } from "@nens/ranalib";
import { getHCCApi } from "@nens/threedi/openapi-client";

import {
  useInvalidateHccLatestRevisionQuery,
  useUpdateHccRevisionQueries,
} from "@/queries/query-hcc-schematisation-revision";

export const useUpdateRevisionMutation = (
  revisionId: number | undefined,
  schematisationId: number | undefined
) => {
  const updateHccRevisionQueries = useUpdateHccRevisionQueries(schematisationId);
  const invalidateHccLatestRevisionQuery = useInvalidateHccLatestRevisionQuery(schematisationId);
  return useMutationWithErrorHandler(
    (data: { commitMessage?: string | null }) => {
      if (!revisionId || !schematisationId)
        throw new Error("revisionId and schematisationId are required");
      return getHCCApi().schematisationsRevisionsPartialUpdate({
        id: revisionId,
        schematisationPk: schematisationId,
        data,
      });
    },
    {
      onSuccess: (data) => {
        if (!revisionId) return;
        updateHccRevisionQueries(revisionId, data);
        invalidateHccLatestRevisionQuery();
      },
    }
  );
};
